(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/enetpulse/assets/enetpulse.js') >= 0) return;  svs.modules.push('/components/sportinfo/enetpulse/assets/enetpulse.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const logger = svs.core.log.getLogger('sportinfo:enetpulse');
const EnetpulseWidgets = svs.components.sportinfo.common.constants.EnetpulseWidgets;
const EnetpulseWidget = _ref => {
  let viewProps = _ref.viewProps,
    externalId = _ref.externalId,
    widgetId = _ref.widgetId,
    DefaultFallbackComp = _ref.FallbackComp;
  const options = useMemo(() => {
    var _viewProps$options;
    return (_viewProps$options = viewProps === null || viewProps === void 0 ? void 0 : viewProps.options) !== null && _viewProps$options !== void 0 ? _viewProps$options : {};
  }, [viewProps]);
  const hasMultipleWidgets = viewProps.hasMultipleWidgets;
  const containerRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldShowFallbackComp = _useState2[0],
    setShouldShowFallbackComp = _useState2[1];
  useEffect(() => {
    if (!externalId || !externalId.Kambi) {
      setShouldShowFallbackComp(true);
      return;
    }
    if (!containerRef.current) {
      setShouldShowFallbackComp(true);
      return;
    }
    const script = document.createElement('script');
    script.id = 'enetpulse-widget';
    script.defer = true;
    let enetpulseIdInitialiser = 'ev';
    if (widgetId === EnetpulseWidgets.TournamentStandings) {
      enetpulseIdInitialiser = 'tsid';
    } else if (widgetId === EnetpulseWidgets.DrawStandings) {
      enetpulseIdInitialiser = 'drid';
    }
    let src = "https://widget.enetscores.com/".concat(widgetId, "/").concat(enetpulseIdInitialiser, "/").concat(externalId.Kambi);
    const optionKeys = Object.keys(options);
    if (optionKeys.length) {
      optionKeys.forEach(key => {
        src += "/".concat(key, "/").concat(options[key]);
      });
    }
    script.async = true;
    script.src = src;
    script.onerror = () => {
      logger.warn("Failed to load Enetpulse widget, showing fallback component, wID: ".concat(widgetId, ", eID: ").concat(externalId.Kambi));
      setShouldShowFallbackComp(true);
    };
    const element = containerRef.current;
    element === null || element === void 0 || element.appendChild(script);
    return () => {
      if (element && element.contains(script)) {
        element.innerHTML = '';
      }
    };
  }, [externalId, options, widgetId]);
  if (shouldShowFallbackComp && !hasMultipleWidgets) {
    return React.createElement(DefaultFallbackComp, null, " F\xF6r tillf\xE4llet g\xE5r de inte att visa n\xE5gon information. ");
  }
  return React.createElement("div", {
    id: "enetpulse-container",
    ref: containerRef
  });
};
setGlobal('svs.components.sportinfo.enetpulse.EnetpulseWidget', EnetpulseWidget);

 })(window);